import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const listInput = basic.input({
    id: "basic-input-list",
    label: "List",
    description: "A simple list, display any group of items in a text list.",
    content: withUniqueClass(
        "list",
        (cls) =>
            `<ul class="${cls}" style="padding-left:18px;margin:0;">
        <li>Item 1</li>
        <li>Item 2</li>
        <li>Item 3</li>
      </ul>`
    ),
});